<div class="cm-landing-fixed-width bk-invite">
	<div class="bk-invite__panel">
		<h2>Ranch Invitation</h2>

		<div *ngIf="state === 'loading'">
			<p>Loading invitation…</p>
		</div>

		<div *ngIf="state === 'invalid'">
			<p>This invitation link is invalid.</p>
			<p>Please ask the person who invited you to resend the invitation.</p>
		</div>

		<div *ngIf="state === 'expired'">
			<p>This invitation has expired.</p>
			<p>Please ask the person who invited you to resend the invitation.</p>
		</div>

		<div *ngIf="state === 'used'">
			<p>This invitation has already been used.</p>
			<p>If you believe this is a mistake, ask the inviter to resend.</p>
		</div>

		<div *ngIf="state === 'error'">
			<p>Something went wrong while loading this invitation.</p>
			<p>Please try again later.</p>
		</div>

		<div *ngIf="state === 'pending_new'">
			<p *ngIf="invite?.RanchName">You’ve been invited to join <strong>{{ invite.RanchName }}</strong>.</p>
			<p *ngIf="invite?.InvitedEmail">Register with <strong>{{ invite.InvitedEmail }}</strong> to join.</p>

			<button mat-button
				class="bk-button bk-button--medium bk-invite__button"
				(click)="goToRegister()">
				Register
			</button>
		</div>

		<div *ngIf="state === 'pending_existing'">
			<p *ngIf="invite?.RanchName">You’ve been invited to join <strong>{{ invite.RanchName }}</strong>.</p>
			<p *ngIf="invite?.InvitedEmail">This invite is for <strong>{{ invite.InvitedEmail }}</strong>.</p>

			<button mat-button
				class="bk-button bk-button--medium bk-invite__button"
				[disabled]="isSaving"
				(click)="acceptInvite()">
				{{ (isSaving ? 'Joining…' : 'Join') }}
				<img class='bk-button__loader' *ngIf='isSaving' src='/assets/images/loader-20px.gif'/>
			</button>
		</div>

		<div *ngIf="state === 'accepted'">
			<p *ngIf="acceptResponse?.RanchName">You’ve been added to <strong>{{ acceptResponse.RanchName }}</strong>.</p>
			<p>Please log in to continue.</p>
			<button mat-button
				class="bk-button bk-button--medium bk-invite__button"
				(click)="goToLogin()">
				Go to login
			</button>
		</div>
	</div>
</div>

